// src/AppRouter.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import InventoryList from './pages/InventoryList';
import InventoryDetail from './pages/InventoryDetail';
import AddInventoryItem from './pages/AddInventoryItem';
import InventoryBulkImport from './pages/InventoryBulkImport'; // Add InventoryBulkImport import
import OrdersList from './pages/OrdersList';
import OrderDetail from './pages/OrderDetail';
import AddOrder from './pages/AddOrder';
import CustomersList from './pages/CustomersList';
import AddCustomer from './pages/AddCustomer';
import CustomerDetail from './pages/CustomerDetail';
import SuppliersList from './pages/SuppliersList';
import AddSupplier from './pages/AddSupplier';
import SupplierDetail from './pages/SupplierDetail';
import Settings from './pages/Settings';
import AuthPage from './pages/AuthPage';
import GoogleAuthCallback from './pages/GoogleAuthCallback';
import ProtectedRoute from './routes/ProtectedRoute';
import AddProductPage from './pages/AddProductPage';
import UsersTab from './pages/UsersTab';
import OrganizationsPage from './pages/OrganizationsPage';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import ProductsBulkImport from './pages/ProductsBulkImport';
import Reports from './pages/Reports';
import UniversalReportsPage from './pages/UniversalReportsPage'; // Add UniversalReportsPage import
import CustomersBulkImport from './pages/CustomersBulkImport';
import SuppliersBulkImport from './pages/SuppliersBulkImport';
import POSOrderPage from './pages/POSOrderPage'; // Add POSOrderPage import
import QuickSalePage from './pages/QuickSalePage';
import QuickPurchasePage from './pages/QuickPurchasePage';
import AccountsReceivable from './pages/AccountsReceivable'; // Import AR component
import AccountsPayable from './pages/AccountsPayable'; // Import AP component

const AppRouter = () => (
  <Routes>
    {/* Public route - must be before other routes */}
    <Route path="/auth" element={<AuthPage />} />
    <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
    
    {/* Protected non-layout routes */}
    <Route path="/list-orgs" element={
      <ProtectedRoute>
        <OrganizationsPage />
      </ProtectedRoute>
    } />
    <Route path="/" element={<Navigate to="/list-orgs" replace />} />
    
    {/* Universal Reports route */}
    <Route path="/reports" element={
      <ProtectedRoute>
        <UniversalReportsPage />
      </ProtectedRoute>
    } />

    {/* Protected Layout routes */}
    <Route element={<Layout />}>
      <Route path="/:orgId/*" element={
        <ProtectedRoute>
          <Routes>
            <Route index element={<Dashboard />} />
            <Route path="customers/bulk-import" element={<CustomersBulkImport />} />
            <Route path="suppliers/bulk-import" element={<SuppliersBulkImport />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/add" element={<AddProductPage />} />
            <Route path="products/bulk-import" element={<ProductsBulkImport />} />
            <Route path="products/:productId" element={<ProductDetail />} />
            <Route path="users" element={<UsersTab />} />
            <Route path="inventory" element={<InventoryList />} />
            <Route path="inventory/add" element={<AddInventoryItem />} />
            <Route path="inventory/bulk-import" element={<InventoryBulkImport />} /> {/* Inventory bulk import route */}
            <Route path="inventory/:productId" element={<InventoryDetail />} />
            <Route path="orders" element={<OrdersList />} />
            <Route path="orders/add" element={<AddOrder />} />
            <Route path="orders/:orderId" element={<OrderDetail />} />
            <Route path="orders/pos" element={<POSOrderPage />} /> {/* POSOrderPage route */}
            <Route path="orders/quick-sale" element={<QuickSalePage />} />
            <Route path="orders/quick-purchase" element={<QuickPurchasePage />} />
            <Route path="customers" element={<CustomersList />} />
            <Route path="customers/add" element={<AddCustomer />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="suppliers" element={<SuppliersList />} />
            <Route path="suppliers/add" element={<AddSupplier />} />
            <Route path="suppliers/:id" element={<SupplierDetail />} />
            <Route path="settings" element={<Settings />} />
            <Route path="reports" element={<Reports />} /> {/* Reports route for specific organization */}
            
            {/* Accounts Receivable/Payable routes */}
            <Route path="accounts-receivable" element={<AccountsReceivable />} />
            <Route path="accounts-receivable/:customerId" element={<AccountsReceivable />} />
            <Route path="accounts-payable" element={<AccountsPayable />} />
            <Route path="accounts-payable/:supplierId" element={<AccountsPayable />} />
          </Routes>
        </ProtectedRoute>
      } />
    </Route>

    {/* Catch-all route */}
    <Route path="*" element={<Navigate to="/list-orgs" replace />} />
  </Routes>
);

export default AppRouter;
